module.exports = __webpack_public_path__ + "static/img/bmw-cic-lrp.2db518a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/bmw-cic-lrp.jpg
// module id = 3H+l
// module chunks = 0